<template>
<div id="page-user-list">
  <div class="flex flex-wrap items-center">
    <!-- ITEMS PER PAGE -->
    <div class="flex-grow">
      <div>
        <vx-card title="ตั้งค่าระบบเกม">
          <vs-table search :data="items" :noDataText="noDataText">
            <template slot="thead">
              <vs-th>code</vs-th>
              <vs-th>name</vs-th>
              <vs-th>setting</vs-th>
              <vs-th>agent url</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.game_code">
                  {{ tr.game_code }}
                </vs-td>
                <vs-td :data="tr.game_name">
                  {{ tr.game_name }}
                </vs-td>
                <vs-td :data="tr.game_setting">
                    <vs-switch @click="update_status(tr.game_no, tr.game_code, tr.game_setting)"
                      :disabled="!$store.state.AppActiveUser.permissions.setting.action" v-model="tr.game_setting">
                      <span slot="on">เปิด</span>
                      <span slot="off">ปิด</span>
                    </vs-switch>
                  </vs-td>
                <vs-td :data="tr.game_agent_url">
                  <a :href="tr.game_agent_url">{{ tr.game_agent_url }}</a>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from '@/axios'

export default {
  components: {},
  data () {
    return {
      items: [],
      noDataText: 'โปรดรอสักครู่...'
    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  },
  async created () {
    let error = null

    const request = await axios.get('games/list').catch((err) => {
      error = err
    })

    if (error) {
      this.$vs.notify({
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถดึงข้อมูลเกมได้ในขณะนี้',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning',
        position: 'top-right'
      })
      this.noDataText = 'ไม่พบรายชื่อเกมส์'
    }

    this.items = request.data.data
  },
  methods: {
    async update_status (game_no, game_code, game_setting) {
      if (game_setting === true) {
        game_setting = false
      } else {
        game_setting = true
      }
      await axios
        .post('games/setting/update', {
          game_no,
          game_code,
          game_setting
        }).then(response => (this.game_response = response.data))

      if (this.game_response.ok === true) {
        this.$vs.notify({
          time: 3000,
          color: game_setting === true ? 'success' : 'warning',
          position: 'top-right',
          icon: game_setting === true ? 'check_box' : 'error',
          title: game_setting === true ? 'เปิด' : 'ปิด',
          text: game_setting === true ? `เกม : ${game_code}` : `เกม : ${game_code}`
        })

      } else {
        this.$vs.notify({
          time: 8000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          title: this.game_response.data.game_setting === false ? 'เปิดระบบ หน้าเว็บไม่สำเร็จ!' : 'ปิดระบบ หน้าเว็บไม่สำเร็จ!',
          text: 'กรุณาติดต่อทีมงานโปรแกรมเมอร์'
        })
        if (game_setting === true) {
          game_setting = true
        } else if (game_setting === false) {
          game_setting = false
        }
      }
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
